<template>
  <section class="gx-bm">
    <batch-modify-shelf v-if="feature" :key="feature" :feature="feature" @back="feature = ''" @created="showRecords" />
    <template v-else>
      <nav class="gx-bm__tabs" role="tablist">
        <button role="tab" :aria-selected="tab === 'modify'" :class="{ on: tab === 'modify' }" @click="tab = 'modify'">修改内容</button>
        <button role="tab" :aria-selected="tab === 'records'" :class="{ on: tab === 'records' }" @click="tab = 'records'">批量修改记录</button>
      </nav>
      <main v-if="tab === 'modify'" class="gx-bm__main">
        <div class="gx-bm__heading"><h1>批量修改</h1></div>
        <section class="gx-bm__group">
          <header><i></i><strong>修改基础信息</strong><small>（2 项）</small></header>
          <div class="gx-bm__grid">
            <button class="gx-bm__card" @click="feature = 'status'"><b>⇅</b><strong>上下架</strong></button>
            <button class="gx-bm__card" @click="feature = 'timer'"><b>◷</b><strong>定时上下架</strong></button>
          </div>
        </section>
      </main>
      <batch-modify-records v-else />
    </template>
  </section>
</template>

<script>
import BatchModifyShelf from './BatchModifyShelf.vue'
import BatchModifyRecords from './BatchModifyRecords.vue'

export default {
  name: 'WechatBatchModifyPage',
  components: { BatchModifyShelf, BatchModifyRecords },
  data: () => ({ feature: '', tab: 'modify' }),
  methods: { showRecords() { this.feature = ''; this.tab = 'records' } }
}
</script>

<style scoped>
.gx-bm { min-height: calc(100vh - 56px); margin: -24px; background: #f5f6f8; color: #1a1a2e; font-family: 'Noto Sans SC', sans-serif; }
.gx-bm button { font: inherit; cursor: pointer; }
.gx-bm__tabs { display: flex; padding: 0 20px; border-bottom: 1px solid #e0e0ec; background: #fff; }
.gx-bm__tabs button { padding: 9px 20px; border: 0; border-bottom: 2px solid transparent; background: #fff; color: #666; font-size: 13px; }
.gx-bm__tabs button.on { border-bottom-color: #c8443c; color: #c8443c; font-weight: 600; }
.gx-bm__main { padding: 14px 20px 24px; }
.gx-bm__heading { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.gx-bm h1 { margin: 0; font-family: 'Noto Serif SC', serif; font-size: 16px; }
.gx-bm__group { margin-bottom: 20px; }
.gx-bm__group > header { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; font-size: 13px; }
.gx-bm__group i { width: 3px; height: 14px; border-radius: 2px; background: #c8443c; }
.gx-bm__group small { color: #999; font-size: 11px; }
.gx-bm__grid { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); gap: 8px; }
.gx-bm__card { position: relative; display: flex; min-height: 58px; flex-direction: column; gap: 4px; padding: 11px 10px 9px; overflow: hidden; border: 2px solid #e0e0ec; border-radius: 6px; background: #f5f0e8; color: #1a1a2e; text-align: left; transition: .15s; }
.gx-bm__card:hover { border-color: #c8443c; background: #fff5f5; }
.gx-bm__card > b { color: #c8443c; font: 16px 'JetBrains Mono', monospace; }
.gx-bm__card strong { font-size: 11px; font-weight: 500; }
@media (max-width: 1180px) { .gx-bm__grid { grid-template-columns: repeat(5, minmax(0, 1fr)); } }
@media (max-width: 820px) { .gx-bm__grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 520px) { .gx-bm { margin: -16px; } .gx-bm__main { padding: 14px 12px 20px; } .gx-bm__tabs { padding: 0 8px; } .gx-bm__tabs button { padding: 9px 12px; } .gx-bm__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
